import React, { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/InvoiceCard.css";
import { fetchOrgHsn } from "../Api/IncomingPo";
import {
  fetchCompanyCodes,
  fetchCustomers,
  fetchProjects,
  fetchResources,
  fetchSupplyTypes,
  fetchOfficeCodes,
  saveInvoiceHeader,
  fetchCategory,
  fetchCompnayCodesById,
  fetchResourceByOrgId,
  fetchCustomersByOrgId,
  fetchOfficeByOrgId,
  fetchCurrency,
} from "../Api/InvoiceApi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Base_URL } from "../url";
//

const CreateInvoice = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [showOrg, setShowOrg] = useState([]);
  const [incomingPoList, setIncomingPoList] = useState([]);
  const [loadingIncomingPo, setLoadingIncomingPo] = useState(false);

  const [formData, setFormData] = useState({
    transactionType: "",
    companyCode: "",
    category: "",
    supplyType: "",
    customerCode: "",
    projectCode: "",
    officeCode: "",
    poNumber: "",                // normalized key (was PONumber in your original)
    poDate: "",
    salespersonCode: "",
    createdBy: String(user?.userId),
    currencyCode: "",
    externalInvoiceNumber: ""    // NEW: holds the External Invoice Number when Incoming PO selected
  });

  const [dropdownData, setDropdownData] = useState({
    companyCodes: [],
    customers: [],
    projects: [],
    resources: [],
    supplyTypes: [],
    officeCodes: [],
    categoryData: [],
    currencyData: []
  });

  const [loading, setLoading] = useState({
    companyCodes: false,
    customers: false,
    projects: false,
    resources: false,
    supplyTypes: false,
    officeCodes: false,
    categoryData: false,
    currencyData: false,
  });

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchAllDropdownData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // When user selects category "Incoming PO" fetch incoming PO headers
    if (formData.category === 'Incoming PO') {
      fetchIncomingPoHeaders();
    } else {
      setIncomingPoList([]);
      // clear any incoming-po-specific fields when not Incoming PO
      setFormData(prev => ({ ...prev, poNumber: "", externalInvoiceNumber: "" }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.category]);

  const fetchAllDropdownData = async () => {
    setLoading({ ...loading, companyCodes: true, customers: true, projects: true, resources: true, supplyTypes: true, officeCodes: true, categoryData: true, currencyData: true });

    try {
      const [companyCodes, customers, projects, resources, supplyTypes, officeCodes, categoryData, showOrgData, currencyData] = await Promise.all([
        fetchCompnayCodesById(user.organisationId),
        fetchCustomersByOrgId(user.organisationId),
        fetchProjects(),
        fetchResourceByOrgId(user.organisationId),
        fetchSupplyTypes(),
        fetchOfficeByOrgId(user.organisationId),
        fetchCategory(user.organisationId),
        fetchOrgHsn(user.organisationId),
        fetchCurrency()
      ]);

      setShowOrg(showOrgData);
      setDropdownData({
        companyCodes: companyCodes || [],
        customers: customers || [],
        projects: projects || [],
        resources: resources || [],
        supplyTypes: supplyTypes || [],
        officeCodes: officeCodes || [],
        categoryData: categoryData || [],
        currencyData: currencyData || []
      });
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
      toast.error("Failed to load dropdown data. Please refresh the page.");
    } finally {
      setLoading({ companyCodes: false, customers: false, projects: false, resources: false, supplyTypes: false, officeCodes: false, categoryData: false, currencyData: false });
    }
  };

  const fetchIncomingPoHeaders = async () => {
    // This fetches from the endpoint: /Invoices/GetIncomingPoHeaders
    // It expects the API to accept orgId as a query parameter. Adjust as necessary.
    setLoadingIncomingPo(true);
    try {
      const orgId = user?.organisationId;
      if (!orgId) {
        setIncomingPoList([]);
        return;
      }
      const res = await fetch(`${Base_URL}/Invoices/GetIncomingPoHeaders`);
      if (!res.ok) throw new Error(`Failed to fetch incoming PO headers: ${res.status}`);
      const data = await res.json();

      // Assume returned items have fields: projectCode and invoiceNumber (adjust if different)
      setIncomingPoList(data || []);
    } catch (err) {
      console.error(err);
      toast.error('Failed to load Incoming PO headers');
      setIncomingPoList([]);
    } finally {
      setLoadingIncomingPo(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  console.log(incomingPoList);

  const handleIncomingPoSelect = (e) => {
    const selectedInvoiceId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      poNumber: selectedInvoiceId || "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const invoiceData = {
        transactionType: formData.transactionType,
        companyCode: formData.companyCode,
        category: formData.category,
        supplyType: formData.supplyType,
        customerCode: formData.customerCode,
        projectCode: formData.projectCode,
        officeCode: formData.officeCode,
        poNumber: formData.poNumber,
        poDate: formData.poDate,
        salespersonCode: formData.salespersonCode,
        createdBy: formData.createdBy,
        currencyCode: formData.currencyCode,
        externalInvoiceNumber: formData.externalInvoiceNumber, // NEW: included in payload
        itemData: []
      };

      const response = await saveInvoiceHeader(invoiceData);

      let invoiceId = "Unknown";
      if (response.message) {
        const match = response.message.match(/'([^']+)'/);
        if (match && match[1]) {
          invoiceId = match[1];
        }
      }

      localStorage.setItem('selectedCustomerCode', formData.customerCode);
      navigate(`/shippingAddress/${invoiceId}`);

    } catch (error) {
      console.error("Error saving invoice:", error);

      let errorMessage = "Failed to save invoice. Please try again.";
      if (error.message) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      }

      toast.error(errorMessage, {
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } finally {
      setSaving(false);
    }
  };

  const handlePostInvoice = () => {
    navigate("/viewUnpostedInvoice");
  };

  return (
    <div className="container-fluid py-4">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="card shadow-sm border-0 rounded-4 p-4 invoice-card mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="fw-bold text-dark mb-1">
              Create Tax Invoice {" "}
              <span className="badge bg-success-light text-success ms-2">
                Regular Supply
              </span>
            </h4>
            <p className="text-muted mb-2">Generate GST compliant invoice with e-invoice/IRN</p>

            <div className="d-flex align-items-center mt-2">
              <span className="badge bg-light text-dark me-2 border pending-badge">⏳ IRN Pending</span>
              <small className="text-muted">Click Generate to create e-invoice</small>
            </div>
          </div>

          <div className="d-flex gap-2">
            <button className="btn btn-outline-primary rounded-3 fw-semibold">💾 Save Draft</button>
            <button className="btn btn-warning rounded-3 fw-semibold text-white">🔐 Generate IRN</button>
            <button className="btn btn-success rounded-3 fw-semibold" onClick={handlePostInvoice}>✅ Post Invoice</button>
          </div>
        </div>
      </div>

      <div className="card shadow-sm border-0 rounded-4 p-4 invoice-header-card">
        <div className="d-flex align-items-center mb-4">
          <div className="icon-box me-2">📄</div>
          <h5 className="fw-bold mb-0 text-dark">Invoice Header Details</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-md-3">
              <label className="form-label fw-semibold">Invoice Type <span className="text-danger">*</span>
                <span className="ms-1 text-muted" title="Select transaction type">?</span>
              </label>
              <select className="form-select" id="transactionType" name="transactionType" value={formData.transactionType} onChange={handleChange} required>
                <option value="">Select Type</option>
                <option value="Invoice">Invoice</option>
                <option value="Sales">Sales</option>
              </select>
            </div>

            <div className="col-md-3">
              <label className="form-label fw-semibold">Company Code <span className="text-danger">*</span>
                <span className="ms-1 text-muted" title="Select company code">?</span>
              </label>
              <select className="form-select" id="companyCode" name="companyCode" value={formData.companyCode} onChange={handleChange} required disabled={loading.companyCodes}>
                <option value="">Select Company</option>
                {dropdownData.companyCodes.map((company) => (
                  <option key={company.companyCode} value={company.companyCode}>{company.companyCode} - {company.name}</option>
                ))}
              </select>
              {loading.companyCodes && <small className="text-muted">Loading...</small>}
            </div>

            <div className="col-md-3">
              <label className="form-label fw-semibold">Category <span className="text-danger">*</span>
                <span className="ms-1 text-muted" title="Select category">?</span>
              </label>
              <select className="form-select" id="category" name="category" value={formData.category} onChange={handleChange} required>
                <option value="">Select Category</option>
                {/* existing categories from API */}
                {dropdownData.categoryData.map((c) => (
                  <option key={c.categoryCode} value={c.categoryCode}>{c.categoryDescription}</option>
                ))}
                {/* Added Incoming PO category option */}
                <option value="Incoming PO">Incoming PO</option>
              </select>
            </div>

            <div className="col-md-3">
              <label className="form-label fw-semibold">Supply Type <span className="text-danger">*</span>
                <span className="ms-1 text-muted" title="Select supply type">?</span>
              </label>
              <select className="form-select" id="supplyType" name="supplyType" value={formData.supplyType} onChange={handleChange} required disabled={loading.supplyTypes}>
                <option value="">Select Supply Type</option>
                {dropdownData.supplyTypes.map((supplyType) => (
                  <option key={supplyType.supplyTypeCode} value={supplyType.supplyTypeCode}>{supplyType.supplyTypeCode} - {supplyType.supplyTypeDescription}</option>
                ))}
              </select>
              {loading.supplyTypes && <small className="text-muted">Loading...</small>}
            </div>
          </div>

          <div className="row g-3 mt-0">
            <div className="col-md-3">
              <label className="form-label fw-semibold">Customer Code <span className="text-danger">*</span>
                <span className="ms-1 text-muted" title="Select customer">?</span>
              </label>
              <select className="form-select" id="customerCode" name="customerCode" value={formData.customerCode} onChange={handleChange} required disabled={loading.customers}>
                <option value="">Select Customer</option>
                {dropdownData.customers.map((customer) => (
                  <option key={customer.customerCode} value={customer.customerCode}>{customer.customerCode} - {customer.name}</option>
                ))}
              </select>
              {loading.customers && <small className="text-muted">Loading...</small>}
            </div>

            {/* If category is Incoming PO show the Incoming PO dropdown */}
            {formData.category === 'Incoming PO' && (
              <>
                <div className="col-md-3">
                  <label className="form-label fw-semibold">Incoming PO Header
                    <span className="ms-1 text-muted" title="Select Incoming PO">?</span>
                  </label>
                  <select
                      className="form-select"
                      id="incomingPo"
                      name="incomingPo"
                      onChange={handleIncomingPoSelect}
                      disabled={loadingIncomingPo}
                    >
                      <option value="">Select Incoming PO</option>
                      {incomingPoList.map((po, idx) => {
                        const val = po.invoiceId; // send only invoiceId
                        const label = `${po.projectCode || po.projCode || ""} - ${
                          po.invoiceNumber || po.invoiceNo || po.invoiceNum || po.invoiceId || ""
                        }-${po.createdAt.split('T')[0]}-${po.createdAt.split('T')[1]}`;
                        return (
                          <option key={idx} value={val}>
                            {label}
                          </option>
                        );
                      })}
                    </select>

                  {loadingIncomingPo && <small className="text-muted">Loading Incoming PO headers...</small>}
                </div>

                <div className="col-md-3">
                  <label className="form-label fw-semibold">External Invoice Number
                    <span className="ms-1 text-muted" title="Enter external invoice number if any">?</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="externalInvoiceNumber"
                    name="externalInvoiceNumber"
                    value={formData.externalInvoiceNumber}
                    onChange={handleChange}
                    placeholder="Enter external invoice number"
                  />
                </div>
              </>
            )}

            {showOrg.projOnInvLine == 'Y' && <div className="col-md-3">
              <label className="form-label fw-semibold">Project Code
                <span className="ms-1 text-muted" title="Select project">?</span>
              </label>
              <select className="form-select" id="projectCode" name="projectCode" value={formData.projectCode} onChange={handleChange} disabled={loading.projects}>
                <option value="">Select Project</option>
                {dropdownData.projects.map((project) => (
                  <option key={project.prozmaPrId} value={project.prozmaPrId}>{project.prozmaPrId} - {project.prTitle}</option>
                ))}
              </select>
              {loading.projects && <small className="text-muted">Loading...</small>}
            </div>}

            <div className="col-md-3">
              <label className="form-label fw-semibold">Office Code <span className="text-danger">*</span>
                <span className="ms-1 text-muted" title="Select office">?</span>
              </label>
              <select className="form-select" id="officeCode" name="officeCode" value={formData.officeCode} onChange={handleChange} required disabled={loading.officeCodes}>
                <option value="">Select Office</option>
                {dropdownData.officeCodes.map((office) => (
                  <option key={office.officeCode} value={office.officeCode}>{office.officeCode} - {office.officeName}</option>
                ))}
              </select>
              {loading.officeCodes && <small className="text-muted">Loading...</small>}
            </div>

            <div className="col-md-3">
              <label className="form-label fw-semibold">Invoice Date <span className="text-danger">*</span>
                <span className="ms-1 text-muted" title="Select PO date">?</span>
              </label>
              <input type="date" className="form-control" id="poDate" name="poDate" value={formData.poDate} onChange={handleChange} required />
            </div>

            <div className="col-md-3">
              <label className="form-label fw-semibold">Currency Code
                <span className="ms-1 text-muted" title="Select Currency Code">?</span>
              </label>
              <select className="form-select" id="currencyCode" name="currencyCode" value={formData.currencyCode} onChange={handleChange} disabled={loading.currencyData}>
                <option value="">Select Currency Code</option>
                {dropdownData.currencyData.map((resource) => (
                  <option key={resource.currencyCodeId} value={resource.currencyCode}>{resource.currencyCodeId} - {resource.currencyCode}</option>
                ))}
              </select>
              {loading.currencyData && <small className="text-muted">Loading Currency Data...</small>}
            </div>
          </div>

          <div className="row g-3 mt-0">
            <div className="col-md-3">
              <label className="form-label fw-semibold">Salesperson Code
                <span className="ms-1 text-muted" title="Select salesperson">?</span>
              </label>
              <select className="form-select" id="salespersonCode" name="salespersonCode" value={formData.salespersonCode} onChange={handleChange} disabled={loading.resources}>
                <option value="">Select Salesperson</option>
                {dropdownData.resources.map((resource) => (
                  <option key={resource.resourceId} value={resource.resourceId}>{resource.resourceId} - {resource.name}</option>
                ))}
              </select>
              {loading.resources && <small className="text-muted">Loading resources...</small>}
            </div>
          </div>

          <div className="d-flex justify-content-center mt-4">
            <button type="submit" className="btn btn-primary rounded-3 fw-semibold px-4" disabled={saving}>{saving ? 'Saving...' : 'Enter Delivery Address'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateInvoice;
